import React from 'react';
import { getLatestScenes } from '../../actions/search';
import Layout from '../../components/Layout';
import { MARKETING_NAV_LINKS } from '../../constants';
import Pricing from './Pricing';

async function action(context) {
  await context.store.dispatch(getLatestScenes());

  return {
    chunks: ['marketing'],
    title: 'Plans & Pricing - Storytape',
    description:
      'Storytape is remarkably affordable. Less than the cost of 1 clip on the big sites. There are no contracts either. Upgrade, downgrade, or cancel at any time.',
    component: (
      <Layout
        transitionId="pricing"
        showHeader={true}
        headerNavLinks={MARKETING_NAV_LINKS}
      >
        <Pricing />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/pricing/index.js